export default {
    ADD_TOKEN: 'ADD_TOKEN',
    REMOVE_TOKEN: 'REMOVE_TOKEN',
    ADD_USER_DETAILS: 'ADD_USER_DETAILS',
    REMOVE_USER_DETAILS: "REMOVE_USER_DETAILS"
}